export function doublePoint(value) {
	return parseInt(value).toFixed(2)
}
// export function statusv(v) {
// 	return v == 1 ? "已签约" : v == 2 ? '已认购' : v == 3 ? '已结佣' : ''
// }


// WEBPACK FOOTER //
// ./src/assets/filter.js